<script>

import Credentials from "./Credentials.svelte";

</script>

<style lang="scss">

  .footer-buenavista{
    width: 100%;
    background-color: #fff;
    color: #fff;
    padding: 25px 10px 0px 10px;
    max-width: 450px;
    margin: auto;

    .img-footer-camara{
      width: 100%;
    }

    .img-footer-buenvista{
      width: 50%;
    }
  }
</style>


<div class="footer-buenavista">
  <div class="text-center mb-4">
      <img class="img-footer-buenvista" src="/img/icon_green_buenavista.png" alt="">
  </div>
  <div class="text-center">
    <img class="img-footer-camara" src="/img/footer_img.png" alt="">
  </div>
  <div class="text-center">
    <p class="mt-2 text-muted"><Credentials /></p>
  </div>
  
</div>